import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import CryptoJS from "crypto-js";
import { jwtDecode } from 'jwt-decode';
import { MedicalContext } from '../Context/MedicalContext';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Modal } from 'flowbite-react';
import medhistory from "../../../JSONS/medhistory.json";
import medhisCodes from "../../../JSONS/medhis_codes.json";

const Recommender = () => {

    const Navigate = useNavigate();
    const MySwal = withReactContent(Swal)

    const {
      PerRecordsCodes, FamRecordsCodes
    } = useContext(MedicalContext);

    const [openModal, setOpenModal] = useState(false);
    const [openModal2, setOpenModal2] = useState(false);
    const [ChosenMedhis, setChosenMedhis] = useState([]);
    const [PastPMedhis,setPastPMedhis] = useState(false)
    const [PastPMedhisRegistry,setPastPMedhisRegistry] = useState(false)
    const [ChosenFamhis, setChosenFamhis] = useState([]);
    const [PastFMedhis,setPastFMedhis] = useState(false)
    const [PastFMedhisRegistry,setPastFMedhisRegistry] = useState(false)
    const [Cardios,setCardios] = useState([])
    const [CardioUp,setCardioUp] = useState([])
    const [ShowCardios,setShowCardios] = useState(false)
    const [FamCardio,setFamCardio] = useState(false)

    const [Height,setHeight] = useState("")
    const [PastHeight,setPastHeight] = useState(false)
    const [Weight,setWeight] = useState("")
    const [PastWeight,setPastWeight] = useState(false)

    const [Ready, setReady] = useState(false)
    const [Ready2, setReady2] = useState(false)
    const [PageStart, setPageStart] = useState(true)
    const [TaskDone, setTaskDone] = useState(false)
    const [Sendoff, setSendoff] = useState(false)

    const [validation, setvalidation] = useState({
      "Weight": "empty",
      "Height": "empty",
    });

    const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
    const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;
    const allowed = decodedToken && decodedToken.first_survey === false && window.localStorage.getItem("OpenAccess") ? JSON.parse(window.localStorage.getItem("OpenAccess")) : decodedToken ? decodedToken.first_survey : false

    const Gender = decodedToken ? parseInt(decodedToken.gender) : null;
    const GenderCat = Gender === 1 ? "M" : "F"

    const DoB = decodedToken ? new Date(decodedToken.born) : null;
    const DoBMonth = DoB ? DoB.getMonth() + 1 : 0
    const DoBDay = DoB ? DoB.getDate() : 0

    function AgeCalc() {
        const currentDate = new Date();
    
        const age = currentDate.getFullYear() - DoB.getFullYear();
        const currentMonth = currentDate.getMonth()+1;
        const currentDay = currentDate.getDate();
    
        if (age > 15) {
          if (currentMonth > DoBMonth || (currentMonth === DoBMonth && currentDay >= DoBDay)) {
            return age;
          } else {
            return age-1;
          }
        } else if (age === 15) {
    
          if (currentMonth > DoBMonth || (currentMonth === DoBMonth && currentDay >= DoBDay)) {
            return age;
          }
        }
    
        return false;
    }
    const Age = DoB ? AgeCalc() : 0
    const ageCat = Age <= 40 ? "15-40" : Age <= 60 ? "41-60" : ">60"

    const getIMC = useCallback((height = Height, weight = Weight) => {
      let imc = parseInt(weight)/(parseInt(height)/100)**2
      let cats = ["Bajo", "Saludable", "Sobrepeso", "Obesidad I", "Obesidad II", "Obesidad III"]
      let which = 0
      let ideal = [0,0]
      if(imc < 18.5) {
          which = 0
      } else if(imc < 25 & imc >= 18.5) {
          which = 1
      } else if(imc < 30 & imc >= 25) {
          which = 2
      } else if(imc < 35 & imc >= 30) {
          which = 3
      } else if(imc < 40 & imc >= 35) {
          which = 4
      } else {
          which = 5
      }
      ideal[0] = Math.round(((height/100)**2) * 18.5)
      ideal[1] = Math.round(((height/100)**2) * 25)
      return [imc, cats[which], which, ideal]
    }, [Height, Weight])
  
    const handleChange = (value, setValue) => {
      const result = value.replace(/\D/g, '');
      setValue(result.slice(0, 3));
    };

    function HandleSubmit() {
      let isWeightValid = Weight.trim() === "" ? "invalid" : "valid";
      let isHeightValid = Height.trim() === "" ? "invalid" : "valid";

      if(Weight < 2 || Weight > 650) {
          isWeightValid = "invalid"
      }
      if(Height < 54 || Height > 272) {
          isHeightValid = "invalid"
      }
  
      setvalidation({
        "Weight": isWeightValid,
        "Height": isHeightValid
      });
  
      if (isWeightValid === "valid" && isHeightValid === "valid"){
        document.body.scrollTop = 0; 
        document.documentElement.scrollTop = 0;
        Weighting()
      }
    }

    const handleMedTiles = (ActiveKey,type) => {
      let tmp = document.getElementById(ActiveKey);
      let tmpList = type === 0 ? ChosenMedhis : ChosenFamhis
      let code = type === 0 ? PerRecordsCodes[ActiveKey] : FamRecordsCodes[ActiveKey]
      let cards = Cardios
  
      if(tmp.className.includes("GenderTileActive")) {
        tmp.className = tmp.className.replace("GenderTileActive", "GenderTile");
        let index = tmpList.indexOf(code);
        if (index > -1) { 
          tmpList.splice(index, 1); 
        }
        if(Cardios.includes(code)) {
          cards = cards.filter( ( el ) => el !== code );
        }
      } else {
        tmp.className = tmp.className.replace("GenderTile", "GenderTileActive");
        if(medhistory.Per_Cardio.includes(ActiveKey)) {
          cards.push(code)
        } else {
          tmpList.push(code)
        }
      }
  
      if(type === 0) {
        setChosenMedhis([...new Set(tmpList)])
        setCardios([...cards])
      } else {
        setChosenFamhis([...new Set(tmpList)])
      }
    }
  
    function showCancer() {
      let tmp = document.getElementById("CancerButton");
      let tmp2 = document.getElementById("CancerDiv");
      let tmpList = ChosenFamhis
  
      if(tmp.className.includes("GenderTileActive")) {
        tmp.className = tmp.className.replace("GenderTileActive", "GenderTile");
        tmp2.className += " FamilyFormBlockHidden"
        for(let i=0;i<medhistory.Family_Cancer.length;i++) {
          if(tmpList.includes(FamRecordsCodes[medhistory.Family_Cancer[i]])) {
            let index = tmpList.indexOf(FamRecordsCodes[medhistory.Family_Cancer[i]]);
            tmpList.splice(index, 1);
          }
        }
      } else {
        tmp.className = tmp.className.replace("GenderTile", "GenderTileActive");
        tmp2.className = tmp2.className.replace(" FamilyFormBlockHidden", "");
      }
      setChosenFamhis([...tmpList])
    }

    function Weighting() {
      let IMC = getIMC(Height,Weight)
      let tmpList = ChosenMedhis
      let which = 0
      switch(Age) {
        case 15:
          if(IMC[0] >= 22.8 && IMC[0] < 27.5) {
            which = 1
          } else if(IMC[0] >= 27.5) {
            which = 2
          }
          break;
        case 16:
          if(IMC[0] >= 23.6 && IMC[0] < 28.4) {
            which = 1
          } else if(IMC[0] >= 28.4) {
            which = 2
          }
          break;
        case 17:
          if(IMC[0] >= 24.4 && IMC[0] < 29.1) {
            which = 1
          } else if(IMC[0] >= 29.1) {
            which = 2
          }
          break;
        default:
          if(IMC[0] >= 25 && IMC[0] < 30) {
            which = 1
          } else if(IMC[0] >= 30) {
            which = 2
          }
          break;
      }
      if(which === 1) {
        tmpList.push(PerRecordsCodes["Sobrepeso"])
        tmpList = tmpList.filter((item) => medhisCodes[item] !== "Obesidad")
        setChosenMedhis([...new Set(tmpList)])
      } else if(which === 2) {
        tmpList.push(PerRecordsCodes["Obesidad"])
        tmpList = tmpList.filter((item) => medhisCodes[item] !== "Sobrepeso")
        setChosenMedhis([...new Set(tmpList)])
      } else {
        tmpList = tmpList.filter((item) => medhisCodes[item] !== "Sobrepeso" && medhisCodes[item] !== "Obesidad")
        setChosenMedhis([...new Set(tmpList)])
      }
      setReady(true)
    }

    const requestGetPatient = useCallback(async() => {

      MySwal.fire({
        position: "center",
        html: 
        <div className="FullAlertWidth1">
            <div className="FullAlertUpTitle">Cargando información de perfil...</div>
            <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
        </div>,
        color: "#340066",
        customClass: 'swal-wide',
        showConfirmButton: false,
        width: "100%",
      })

      let parameters = {
        rut: decodedToken.rut
      }
  
      let requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(parameters)
      };

      let params2 = {
        rut: decodedToken.rut,
        within: [51,52]
      }
  
      let requestOptions2 = {
        method: 'POST',
        redirect: 'follow',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(params2)
      };
  
      try{
        let resp = await fetch("https://ymc-doc-api.azurewebsites.net/getprofiledata", requestOptions)
        if (resp.status !== 200){
            MySwal.fire({
                icon: "error",
                title: "Ocurrió un error obteniendo los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
            });
            return false;
        }
        let data = await resp.json();
        
        if(data.pmh && data.pmh.length !== 0) {
          setChosenMedhis([...data.pmh])
          setPastPMedhis(true)
          setPastPMedhisRegistry([...data.pmh])
          if(data.pmh.includes("AP035")) {
            setShowCardios(true)
            if(data.enf_card) {
              setCardios([...data.enf_card])
              setCardioUp([...data.enf_card])
            }
          }
        }
        if(data.fmh && data.fmh.length !== 0) {
          setChosenFamhis([...data.fmh])
          setPastFMedhis(true)
          setPastFMedhisRegistry([...data.fmh])
          if(data.fmh.includes("AF025") && data.fam_card) {
            setFamCardio(data.fam_card)
          }
        }

        let hasParams = true
        let resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/getuserparams", requestOptions2)
        if (resp2.status !== 200){
            if(resp2.status !== 500) {
              MySwal.fire({
                  icon: "error",
                  title: "Ocurrió un error al subir los datos",
                  text: "Por favor inténtelo más tarde",
                  showConfirmButton: true
              });
              return false;
            } else {
              hasParams = false
            }
        }
        let data2 = await resp2.json();
        
        if(hasParams) {
            if(data2.params["51"]) {
              setWeight(data2.params["51"][1])
              setPastWeight(true)
            }
            if(data2.params["52"]) {
              setHeight(data2.params["52"][1])
              setPastHeight(true)
            }
        }

        MySwal.close();
        setTaskDone(true);
      }
      catch(error){
          MySwal.close();
          alert("Ocurrió un error procesando la búsqueda");
          return false;
      }
    },[MySwal,decodedToken]);

    useEffect(() => {
        if(PageStart && allowed) {
          requestGetPatient()
          setPageStart(false)
        }
    }, [PageStart, requestGetPatient, allowed])

    const uploadChanges = useCallback( async() => {

      MySwal.fire({
        position: "center",
        html: 
        <div className="FullAlertWidth1">
            <div className="FullAlertUpTitle">Subiendo datos...</div>
            <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
        </div>,
        color: "#340066",
        customClass: 'swal-wide',
        showConfirmButton: false,
        width: "100%",
      })

      let upload1 = true
      let upload2 = true

      let Dated = new Date()

      let personal = ChosenMedhis
      let familiar = ChosenFamhis

      if(Cardios.length === 0) {
        personal = personal.filter((med) => med !== "AP035")
      }

      let params = {
        rut: decodedToken.rut,
        pers: personal,
        fam: familiar,
        enf_card: personal.includes("AP035") && Cardios.length !== 0 ? Cardios : false,
        fam_card: familiar.includes("AF025") && FamCardio ? FamCardio : false
      }

      let containsAll = (arr1, arr2) => arr2.every(arr2Item => arr1.includes(arr2Item))
      const sameMembers = (arr1, arr2) => containsAll(arr1, arr2) && containsAll(arr2, arr1);
      if(PastPMedhisRegistry && PastFMedhisRegistry) {
        if(sameMembers(PastPMedhisRegistry, personal) && sameMembers(Cardios, CardioUp) && sameMembers(PastFMedhisRegistry, familiar)) {
          upload1 = false
        }
      } else if(PastPMedhisRegistry) {
        if(sameMembers(PastPMedhisRegistry, personal) && sameMembers(Cardios, CardioUp)) {
          upload1 = false
        }
      } else if(PastFMedhisRegistry) {
        if(sameMembers(PastFMedhisRegistry, familiar)) {
          upload1 = false
        }
      } else {
        upload1 = false
      }
      let allpersonals = personal.concat(Cardios)

      let requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: {
        "Content-Type": "application/json",
        },
        body: JSON.stringify(params)
      };

      let finalParamids = [
        !PastWeight ? 51 : false,
        !PastHeight ? 52 : false,
      ].filter(med => med !== false);
      let finalResults = [
        !PastWeight ? Weight : false,
        !PastHeight ? Height : false,
      ].filter(med => med !== false);

      if (PastWeight && parseInt(PastWeight) === parseInt(Weight) && PastHeight && parseInt(PastHeight) === parseInt(Height)) {
        upload2 = false
      }
  
      let params2 = {
        rut: decodedToken.rut,
        sex: GenderCat,
        ans: upload2 ? finalResults : false,
        ids: upload2 ? finalParamids : false,
        pmh: upload1 ? allpersonals : false,
        fmh: upload1 ? familiar : false,
        date: Dated
      }

      let requestOptions2 = {
        method: 'POST',
        redirect: 'follow',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params2)
      };
  
      try{
        if(upload1) {
          const resp = await fetch("https://ymc-doc-api.azurewebsites.net/updateusermedhis", requestOptions)
          if (resp.status !== 200){
            MySwal.fire({
              icon: "error",
              title: "Ocurrió un error al subir los datos",
              text: "Por favor inténtelo más tarde",
              showConfirmButton: true
            });
            return false;
          }
        }

        if(upload2 || upload1) {
          const resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/addnewparamresults", requestOptions2)
          if (resp2.status !== 200){
            MySwal.fire({
              icon: "error",
              title: "Ocurrió un error al subir los datos",
              text: "Por favor inténtelo más tarde",
              showConfirmButton: true
            });
            return false;
          }
        }

        setReady2(true)
        document.body.scrollTop = 0; 
        document.documentElement.scrollTop = 0;
        
        MySwal.close();
      }
      catch(error){
          console.log(error)
          MySwal.fire({
              icon: "error",
              title: "Ocurrió un error al subir los datos",
              text: "Por favor inténtelo más tarde",
              showConfirmButton: true
          });
          return false
      }
    },[Height,MySwal,PastHeight,PastWeight,Weight,decodedToken,CardioUp,Cardios,ChosenFamhis,ChosenMedhis,FamCardio,PastFMedhisRegistry,PastPMedhisRegistry])

    const getRecommendedStuff = useCallback(async() => {

      MySwal.fire({
        position: "center",
        html: 
        <div className="FullAlertWidth1">
            <div className="FullAlertUpTitle">Cargando Orden Personalizada...</div>
            <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
        </div>,
        color: "#340066",
        customClass: 'swal-wide',
        showConfirmButton: false,
        width: "100%",
      })

      let allMedHis = []
      allMedHis.push(...ChosenMedhis)
      allMedHis.push(...ChosenFamhis)

      let params = {
        meds: allMedHis,
        sex: GenderCat,
        age: Age
      };

      let requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(params)
      };
  
      let params2 = {
        p_medhis: ChosenMedhis,
        f_medhis: ChosenFamhis
      };
    
      let requestOptions2 = {
        method: 'POST',
        redirect: 'follow',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params2)
      };
  
      try{

        const resp = await fetch("https://ymc-graph-api.azurewebsites.net/getrecommendedexams", requestOptions)
        if (resp.status !== 200){
          MySwal.fire({
            icon: "error",
            title: "Ocurrió un error en el servidor",
            text: "Por favor inténtelo más tarde",
            showConfirmButton: true
          });
          return false;
        }
        const data = await resp.json();
        if(data) localStorage.setItem('PreviewRelatedExams', JSON.stringify(data));
        
        const resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/getrecommendedpacks", requestOptions2)
        if (resp2.status !== 200){
          MySwal.fire({
            icon: "error",
            title: "Ocurrió un error en el servidor",
            text: "Por favor inténtelo más tarde",
            showConfirmButton: true
          });
          return false;
        }
        const data2 = await resp2.json();
        
        if(data2) localStorage.setItem('AllPacks', JSON.stringify(data2));
    
        setSendoff(true)
        MySwal.close()
      }
      catch(error){
        console.log(error)
        MySwal.fire({
          icon: "error",
          title: "Ocurrió un error en el servidor",
          text: "Por favor inténtelo más tarde",
          showConfirmButton: true
        });
        return false
      }
    },[Age,ChosenFamhis,ChosenMedhis,GenderCat,MySwal])

    useEffect(() => {
      if(Sendoff) {
        Navigate("/recomendador-de-examenes/recomendacion")
        setSendoff(false)
      }
      if(Ready) {
        uploadChanges()
        setReady(false)
      }
      if(Ready2) {
        getRecommendedStuff()
        setReady2(false)
      }
    }, [Sendoff,Ready,Navigate,getRecommendedStuff,Ready2,uploadChanges]);

    function showCardio() {
      let tmp = document.getElementById("CardioButton");
      let tmp2 = document.getElementById("CardioDiv");
      let tmpList = ChosenMedhis
      if(tmp.className.includes("GenderTileActive")) {
        tmp.className = tmp.className.replace("GenderTileActive", "GenderTile");
        tmp2.className += " FamilyFormBlockHidden"
        setCardios([])
        setChosenMedhis([...tmpList.filter((item) => item !== "AP035")])
      } else {
        tmp.className = tmp.className.replace("GenderTile", "GenderTileActive");
        tmp2.className = tmp2.className.replace(" FamilyFormBlockHidden", "");
        tmpList.push("AP035")
        setChosenMedhis([...tmpList])
      }
      setShowCardios(!ShowCardios)
  }

    //function toggleAdditional2(id) {
    //    let tmp = document.getElementById(id)
    //    if(tmp.className.includes("UserWelcomeBlockPage1SpecificsHidden")) {
    //      tmp.className = tmp.className.replace(" UserWelcomeBlockPage1SpecificsHidden", "");
    //    } else {
    //      tmp.className += " UserWelcomeBlockPage1SpecificsHidden"
    //    }
    //}

    return (
        <div className='UserProfileFull'>
          <div className='UserProfileInnerDiv'>
            <div className='UserProfileInnerDivCalculatorWhiteBlock2'>
            { TaskDone ?
            <>
            <div className='UserWelcomeBlockPageWideFlex'>
              <div className='UserWelcomeBlockPageWideSideL'>
                <div className='UserWelcomeBlockPage1TitleFlex' style={{marginBlockEnd:"15px"}}>
                    <div className='UserWelcomeBlockPage1Title'>Recomendación de exámenes preventivos&ensp;</div>
                    {/*<div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional2("Added1")}>?</div>*/}
                </div>
                {/*<div className="UserWelcomeBlockPage1Specifics UserWelcomeBlockPage1SpecificsHidden" id="Added1">El test de Findrisc es un cuestionario permite detectar el riesgo de desarrollar diabetes en los próximos 10 años.</div>*/}
                <h4 className="UserProfileHeartAgeCalculatorWhiteBlockTitle UserProfileHeartAgeCalculatorWhiteBlockTitleThin">Completa tus datos y obtén una orden médica con exámenes preventivos diseñados para ti.</h4>
                <div className='UserProfileHeartAgeCalculatorWhiteBlockSubtitle' style={{textAlign:"left", marginBlockEnd:"20px"}}>Te facilitamos el acceso a ordenes médicas con exámenes de laboratorio, imágenes y procedimientos que te permiten detectar precozmente patologías como diabetes, hipertensión, dislipidemia y algunos de los cánceres más frecuentes en la población.</div>
              </div>
              <div className='UserWelcomeBlockPageWideSideR'>
                <h4 className="UserWelcomeBlockYNQuestion2">Mi Historial Médico</h4>
                <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompleted">
                    • Edad: {Age}<br/>
                    • Sexo al Nacer: {Gender === 1 ? "Hombre" : "Mujer"}<br/>
                    {PastHeight ?
                    <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Estatura: {Height}</div>
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastHeight(false)}>Editar
                        <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                        </div>
                    </div>
                    : null}
                    {PastWeight ? 
                    <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Peso: {Weight} Kg</div>
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastWeight(false)}>Editar
                        <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                        </div>
                    </div>
                    : null}
                    {PastPMedhis ? 
                    <>
                    <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Antecedentes Personales:</div>
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastPMedhis(false)}>Editar
                        <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                        </div>
                    </div>
                    <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhisBlocks'>
                      {ChosenMedhis.filter((med) => med !== "AP035").map((medhis) => (
                        <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhis' key={medhis}>{medhisCodes[medhis]}</div>
                      ))}
                      {Cardios.map((medhis) => (
                        <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhis' key={medhis}>{medhisCodes[medhis]}</div>
                      ))}
                    </div>
                    </>
                    : null}
                    {PastFMedhis ? 
                    <>
                    <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Antecedentes Familiares:</div>
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastFMedhis(false)}>Editar
                        <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                        </div>
                    </div>
                    <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhisBlocks'>
                      {ChosenFamhis.map((medhis) => (
                        <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhis' key={medhis}>{medhisCodes[medhis]}</div>
                      ))}
                    </div>
                    </>
                    : null}
                </div>
                <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestionFlex">
                  { PastWeight ?
                  null
                  :
                  <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion">
                      <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Weight"] === "invalid" ? "red" : validation["Weight"] === "valid" ? "#8BC53F" : null}}>Ingresa tu peso </div>
                      <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                      <input
                          value={Weight}
                          className="SignInInnerBoxInputTile"
                          style={{ borderBottom: validation["Weight"] === "invalid" ? "red solid 1px" : validation["Weight"] === "valid" ? "#8BC53F solid 1px" : Weight.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Weight"] === "invalid" ? "#FFFAEA" : validation["Weight"] === "valid" || Weight.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                          id="YMCWeight"
                          onChange={(e) => handleChange(e.target.value,setWeight)}/>
                      <div className="DiabetesRiskCalculatorRightSideSurveyQ4InputMeasure">kg</div>
                      </div>
                      {validation["Weight"] === "invalid" ?
                          <div className='WeightAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                      : null }
                  </div>
    }
                  { PastHeight ?
                      null
                  :
                  <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion">
                      <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Height"] === "invalid" ? "red" : validation["Height"] === "valid" ? "#8BC53F" : null}}>Ingresa tu altura </div>
                      <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                      <input
                          value={Height}
                          className="SignInInnerBoxInputTile"
                          style={{ borderBottom: validation["Height"] === "invalid" ? "red solid 1px" : validation["Height"] === "valid" ? "#8BC53F solid 1px" : Height.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Height"] === "invalid" ? "#FFFAEA" : validation["Height"] === "valid" || Height.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                          id="YMCHeight"
                          onChange={(e) => handleChange(e.target.value,setHeight)}/>
                      <div className="DiabetesRiskCalculatorRightSideSurveyQ4InputMeasure">cm</div>
                      </div>
                      {validation["Height"] === "invalid" ?
                          <div className='HeightAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                      : null }
                  </div>
    }
                </div>
                { PastPMedhis ?
                  null
                : ChosenMedhis.length === 0 ?
                <div className='GeneralWhiteButtonFlex UserProfileInnerDivCalculatorWhiteBlockRightButton' onClick={() => setOpenModal(true)}>
                  <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonInner'>
                    <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonText'>Antecedentes Personales</div>
                    <img alt="Plus Icon" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurplePlusCircleIcon.svg" />
                  </div>
                </div>
                :
                <div className='UserProfileInnerDivCalculatorWhiteBlockDoneBlock' style={{marginBlockEnd:"20px"}}>
                  <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonInner'>
                    <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonText'>Antecedentes Personales</div>
                  </div>
                  <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlock'>
                      <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockLeft'>
                        <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhisBlocks'>
                          {ChosenMedhis.filter((med) => med !== "AP035").map((medhis) => (
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhis' key={medhis}>{String(medhisCodes[medhis])}</div>
                          ))}
                          {Cardios.map((medhis) => (
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhis' key={medhis}>{String(medhisCodes[medhis])}</div>
                          ))}
                        </div>
                      </div>
                      <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockRightButton' onClick={() => setOpenModal(true)}>
                          <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockRightButtonText'>Modificar</div>
                      </div>
                  </div>
                </div>
    }
                { PastFMedhis ?
                  null
                : ChosenFamhis.length === 0 ?
                <div className='GeneralWhiteButtonFlex UserProfileInnerDivCalculatorWhiteBlockRightButton' onClick={() => setOpenModal2(true)}>
                  <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonInner'>
                    <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonText'>Antecedentes Familiares</div>
                    <img alt="Plus Icon" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurplePlusCircleIcon.svg" />
                  </div>
                </div>
                :
                <div className='UserProfileInnerDivCalculatorWhiteBlockDoneBlock' style={{marginBlockEnd:"20px"}}>
                  <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonInner'>
                    <div className='UserProfileInnerDivCalculatorWhiteBlockRightButtonText'>Antecedentes Familiares</div>
                  </div>
                  <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlock'>
                      <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockLeft'>
                        <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhisBlocks'>
                          {ChosenFamhis.map((medhis) => (
                            <div className='UserProfileHealthReportUpperBlockRightSideDivideMedhis' key={medhis}>{medhisCodes[medhis]}</div>
                          ))}
                        </div>
                      </div>
                      <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockRightButton' onClick={() => setOpenModal2(true)}>
                          <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockRightButtonText'>Modificar</div>
                      </div>
                  </div>
                </div>
    }
              </div>
            </div>
            <div className='GeneralPurpleButtonFlex UserProfileHeartAgeCalculatorWhiteBlockSubmitButton' onClick={() => HandleSubmit()}>Siguiente<div className='triangle'><i className='innerarrowWhite'></i></div></div>

            <Modal dismissible show={openModal} position="center" className='UserWelcomeBlockModal'>
              <Modal.Body className='UserWelcomeBlockwModalBody'>
                <div className='UserWelcomeBlockPage1TitleFlex'>
                  <div className='UserWelcomeBlockPage1Title'>Recomendación inteligente de exámenes preventivos&ensp;</div>
                  <div className="UserWelcomeBlockModalXSymbol" onClick={() => setOpenModal(false)}></div>
                </div>
                <h2 className='UserWelcomeBlockModalBodyTitle'>Antecedentes Personales</h2>
                <div className='UserProfileHeartAgeCalculatorWhiteBlockTitle' style={{marginInline:"0px"}}>¿Te han diagnosticado alguna de las siguientes enfermedades?</div>
                <div className='MedicalHistoryFormButtons UserWelcomeBlockModalMedhisGrid'>
                  {Object.keys(medhistory.Personal).filter(a => medhistory.Personal[a].age_cat.includes(ageCat)).filter(a => medhistory.Personal[a].gender.includes(GenderCat)).filter((item) => item !== "Sobrepeso" && item !== "Obesidad").map((history) => (
                    <div className={ChosenMedhis.includes(PerRecordsCodes[history]) ? "MedicalFormIndividualButton GenderTile rounded-2 GenderTileActive" : "MedicalFormIndividualButton GenderTile rounded-2 "} id={history} key={history+'P'} onClick={() => handleMedTiles(history,0)}>
                      {history} </div>
                  ))}
                  <div className={ShowCardios ? "MedicalFormIndividualButton GenderTile rounded-2 GenderTileActive" : "MedicalFormIndividualButton GenderTile rounded-2 "} id="CardioButton" onClick={() => showCardio()}>
                  Enfermedad Cardiovascular</div>
                </div>
                <div className={ShowCardios ? "FamilyFormBlock" : "FamilyFormBlock FamilyFormBlockHidden"} id="CardioDiv">
                    <div className='UserProfileHeartAgeCalculatorWhiteBlockTitle' style={{marginInline:"0px"}}>Seleccione el(los) tipo(s) de enfermedades cardiovasculares.</div>
                    <div className='MedicalHistoryFormButtons'>
                        {medhistory.Per_Cardio.map((history) => (
                        <div className={Cardios.includes(PerRecordsCodes[history]) ? "MedicalFormIndividualButton GenderTile rounded-2 GenderTileActive" : "MedicalFormIndividualButton GenderTile rounded-2 "} key={history+'P'} id={history} onClick={() => handleMedTiles(history,0)}>
                            {history} </div>
                        ))}
                    </div>
                </div>
                  <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton UserWelcomeBlockModalSaveButton" onClick={() => {setOpenModal(false); setShowCardios(Cardios.length === 0 ? false : true);}}>
                    <div className="GeneralPurpleButtonText">Guardar</div>
                    <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                  </div>
              </Modal.Body>
            </Modal>
            <Modal dismissible show={openModal2} position="center" className='UserWelcomeBlockModal'>
              <Modal.Body className='UserWelcomeBlockwModalBody'>
                <div className='UserWelcomeBlockPage1TitleFlex'>
                  <div className='UserWelcomeBlockPage1Title'>Recomendación inteligente de exámenes preventivos&ensp;</div>
                  <div className="UserWelcomeBlockModalXSymbol" onClick={() => setOpenModal2(false)}></div>
                </div>
                <h2 className='UserWelcomeBlockModalBodyTitle'>Antecedentes Familiares</h2>
                <div className='UserProfileHeartAgeCalculatorWhiteBlockTitle' style={{marginInline:"0px"}}>¿Sabes si alguno de tus familiares directos (como padres, hermanos, tíos y abuelos) ha sido diagnosticado o está en tratamiento por alguna de estas patologias?</div>
                <div className="FamilyFormBlock">
                  <div className='MedicalHistoryFormButtons'>
                  {medhistory.Family_Patho.map((history) => (
                    <div className={ChosenFamhis.includes(FamRecordsCodes[history]) ? "FamilyFormIndividualButton GenderTile rounded-2 GenderTileActive" : "FamilyFormIndividualButton GenderTile rounded-2 "} key={history+'F'} id={history} onClick={() => handleMedTiles(history,1)}>
                      {history} </div>
                  ))}
                  <div className={ChosenFamhis.filter(s => medhisCodes[s].includes("Cáncer")).length !== 0 ? "FamilyFormIndividualButton GenderTile rounded-2 GenderTileActive" : "FamilyFormIndividualButton GenderTile rounded-2 "} id="CancerButton" onClick={() => showCancer()}>
                    Cáncer </div>
                  </div>
                </div>

                <div className={ChosenFamhis.filter(s => medhisCodes[s].includes("Cáncer")).length !== 0 ? "FamilyFormBlock" : "FamilyFormBlock FamilyFormBlockHidden"} id="CancerDiv">
                  <div className='UserProfileHeartAgeCalculatorWhiteBlockTitle' style={{marginInline:"0px"}}>Seleccione el(los) tipo(s) de cáncer</div>
                  <div className='MedicalHistoryFormButtons'>
                    {medhistory.Family_Cancer.map((history) => (
                      <div className={ChosenFamhis.includes(medhisCodes[history]) ? "FamilyFormIndividualButton GenderTile rounded-2 GenderTileActive" : "FamilyFormIndividualButton GenderTile rounded-2 "} key={history+'F'} id={history} onClick={() => handleMedTiles(history,1)}>
                        {history} </div>
                    ))}
                  </div>
                </div>
                <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton UserWelcomeBlockModalSaveButton" onClick={() => setOpenModal2(false)}>
                  <div className="GeneralPurpleButtonText">Guardar</div>
                  <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                </div>
              </Modal.Body>
            </Modal>
            </>
          : null}
          </div>
        </div>
      </div>
    );
};

export default Recommender;